import React from "react";
import "./SideNav.css";
import { SiTrello } from "react-icons/si";
import { HiTemplate } from "react-icons/hi";
import { TbActivityHeartbeat } from "react-icons/tb";
import { BsSuitHeart } from "react-icons/bs";
import { AiOutlineUsergroupAdd, AiOutlineSetting } from "react-icons/ai";

const SideNav = () => {
  return (
    <>
      <div className="sideNavWrapper">
        <div className="button-container">
          <ul>
            <li
              style={{
                display: "flex",
                gap: "8px",
                backgroundColor: "#caf0f88e",
                width: "250px",
                padding: "2px",
                marginTop: "12px",
              }}
            >
              <SiTrello />
              Boards
            </li>
            <li
              style={{
                display: "flex",
                gap: "8px",
                width: "250px",
                padding: "2px",
                marginTop: "12px",
              }}
            >
              <HiTemplate />
              Templates
            </li>
            <li
              style={{
                display: "flex",
                gap: "8px",
                width: "250px",
                padding: "2px",
                marginTop: "12px",
              }}
            >
              <TbActivityHeartbeat />
              Home
            </li>
          </ul>
        </div>

        <div
          style={{
            gap: "8px",
            marginTop: "25px",
            width: "250px",
            padding: "2px",
            fontWeight: "800",
          }}
        >
          <span
            style={{
              backgroundColor: "#4CA1A3",
              color: "white",
              padding: "3px",
              fontSize: "20px",
              marginRight: "4px",
              borderRadius: "2px",
              paddingTop: "8px",
            }}
          >
            N{" "}
          </span>{" "}
          New Workspace
        </div>

        <div className="list-item-wrapper">
          <ul style={{ gap: "55px", fontSize: "14px" }}>
            <li
              style={{
                display: "flex",
                gap: "15px",
                marginBottom: "18px",
                // color: "#DFDFDE",
              }}
            >
              <SiTrello />
              Boards
            </li>
            <li style={{ display: "flex", gap: "15px", marginBottom: "18px" }}>
              <BsSuitHeart />
              Highlights
            </li>
            <li style={{ display: "flex", gap: "15px", marginBottom: "18px" }}>
              <AiOutlineUsergroupAdd />
              Members
            </li>
            <li style={{ display: "flex", gap: "15px", marginBottom: "18px" }}>
              <AiOutlineSetting />
              Settings
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default SideNav;
